export default "__VITE_ASSET__5oX3xwIR__"